import { useEffect } from 'react';
import throttle from 'lodash/throttle';

export function useParentSessionMonitor(): void {
  useEffect(() => {
    if (window.top === window.self) return;

    const sessionCheck = () => window.parent.postMessage({ key: 'sessionCheck' }, '*');

    // Throttle session checks to once per minute to reduce overhead
    const throttledSessionCheck = throttle(sessionCheck, 60000, { leading: true, trailing: false });
    const sessionCheckOnVisibilityChange = () => {
      if (!document.hidden) {
        sessionCheck();
      }
    };

    // Listen for user interactions to trigger session checks
    document.addEventListener('mousemove', throttledSessionCheck);
    document.addEventListener('click', throttledSessionCheck);
    document.addEventListener('keydown', throttledSessionCheck);
    document.addEventListener('visibilitychange', sessionCheckOnVisibilityChange);

    return () => {
      document.removeEventListener('mousemove', throttledSessionCheck);
      document.removeEventListener('click', throttledSessionCheck);
      document.removeEventListener('keydown', throttledSessionCheck);
      document.removeEventListener('visibilitychange', sessionCheckOnVisibilityChange);
      throttledSessionCheck.cancel();
    };
  }, []);
}
